import type {HealthCheckItem} from '~/types/types'

const defaultHealthCheck: HealthCheckItem = {
  insightsTimeScalesDatabaseUp: true,
 insightsAppDatabaseUp: true
}

export const useSystemApi = () => {
  const api = getApiConstants()
  const http = useHttp()

  const getHealthCheck = async () => {
    try {
      const api = getApiConstants()
      const http = useHttp()

      return await http.get<HealthCheckItem>(`${api.SYSTEM}gethealthcheck`, true)
    } catch (e) {
      return defaultHealthCheck
    }
  }

  return {
    getHealthCheck,
    defaultHealthCheck
  }
}
